export const INPUT_SUCCESS = "INPUT_SUCCESS";
export const INPUT_FAIL = "INPUT_FAIL";
export const SESSION_SUCCESS = "SESSION_SUCCESS";
export const SESSION_FAIL = "SESSION_FAIL";
export const MESSAGE_SUCCESS = "MESSAGE_SUCCESS";
export const MESSAGE_FAIL = "MESSAGE_FAIL";
